import { useEffect, useState } from "react";
import styles from "./addBooking.module.css";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import axios from "axios";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import MapComponent from "../../../../fontend/components/Map";
import { usePlacesWidget } from "react-google-autocomplete";
import { authData } from "../../../components/GetAuth";
import { Plus, Trash2 } from "react-feather";

function Step2({ saveStep2Data, backToTab, bookingData, selectCountry, customerEmail }) {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [defaultCustomer, setDefaultCustomer] = useState("");
  const [userAddressList, setUserAddressList] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 51.509865, lng: -0.118092 });
  const [isMarker, setIsMarker] = useState(false);
  const [zoom, setZoom] = useState(12);

  const { register, handleSubmit, control, formState: { errors }, clearErrors, setValue } = useForm({
    mode: "onChange",
    defaultValues: {
      customer_id: "",
      name: "",
      email: customerEmail,
      phone: "",
      address: "",
      post_code: "",
    },
  });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "alt_phones"
  });

  const { ref: placeRef1 } = usePlacesWidget({
    apiKey: process.env.REACT_APP_MAP_API_KEY,
    onPlaceSelected: (place) => {
      setValue("address", place.formatted_address);
      setValue("latitude", place.geometry.location.lat());
      setValue("longitude", place.geometry.location.lng());

      setMapCenter({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });
      setIsMarker(true);
      setZoom(18);

      place?.address_components.forEach((item) => {
        if (item.types.indexOf("postal_code") > -1) {
          setValue("post_code", item.long_name);
        }
      });
    },
    options: {
      types: ["address"],
      componentRestrictions: { country: selectCountry }
    },
  });

  useEffect(() => {
    if (bookingData?.customer_id) {
      axios.get(process.env.REACT_APP_API_URL + "v1/adresses/" + bookingData?.customer_id + "/pickup", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`
        }
      }).then((response) => {
        if (response.data.status === "SUCCESS") {
          setUserAddressList([{ value: -1, name: "New record" }].concat(response.data.data));
          if (!bookingData?.pickUpData) {
            setValue("customer_id", 0);
            setDefaultCustomer(0);
          }
        }
      });
    }
  }, [API_TOKEN, bookingData?.customer_id, bookingData?.pickUpData, setValue]);

  useEffect(() => {
    setValue("customer_id", bookingData?.pickUpData?.customer_id);
    setValue("name", bookingData?.pickUpData?.name);
    setValue("email", customerEmail);
    setValue("phone", bookingData?.pickUpData?.phone);
    setValue("address", bookingData?.pickUpData?.address);
    setValue("post_code", bookingData?.pickUpData?.post_code);

    if (bookingData && bookingData?.pickUpData) {
      if (bookingData?.pickUpData?.alt_phones?.length) {
        replace(bookingData?.pickUpData?.alt_phones)
      }
    }

    if (bookingData?.pickUpData?.latitude && bookingData?.pickUpData?.longitude) {
      setValue("latitude", bookingData?.pickUpData?.latitude);
      setValue("longitude", bookingData?.pickUpData?.longitude);
      setMapCenter({ lat: parseFloat(bookingData?.pickUpData?.latitude), lng: parseFloat(bookingData?.pickUpData?.longitude) });
      setIsMarker(true);
      setZoom(18);
    }
  }, [bookingData, setValue, customerEmail]);

  useEffect(() => {
    if (defaultCustomer === -1) {
      setValue(`name`, "");
      setValue(`phone`, "");
      setValue(`address`, "");
      setValue(`post_code`, "");
      setIsMarker(false);
      setZoom(18);
    } else {
      let addressObj = userAddressList.filter((i) => i?.value === defaultCustomer);
      if (addressObj.length > 0) {
        addressObj = addressObj[0];

        setValue("name", addressObj?.name);
        setValue("email", customerEmail);
        setValue("phone", addressObj?.phone);
        setValue("address", addressObj?.address);
        setValue("post_code", addressObj?.post_code);

        if (addressObj?.latitude && addressObj?.longitude) {
          setValue(`latitude`, parseFloat(addressObj?.latitude));
          setValue(`longitude`, parseFloat(addressObj?.longitude));
          setMapCenter({ lat: parseFloat(addressObj?.latitude), lng: parseFloat(addressObj?.longitude) });
          setIsMarker(true);
          setZoom(18);
        }

        clearErrors();
      }
    }
  }, [defaultCustomer, userAddressList, clearErrors, setValue, customerEmail]);

  const onSubmit = (data) => {
    data = { ...data, email: customerEmail };
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: "instant" });
    saveStep2Data(data);
  };

  return (<>
    <div className={`${styles.StepOneForm}`}>
      <form id="step2-form" onSubmit={handleSubmit(onSubmit)}>
        <div className={`${styles.StepOneFormRow}`}>
          <div className={`${styles.StepOneFormBig}`}>
            <div className={`FormFullGroup`} style={{ marginBottom: '20px' }}>
              <FormControl fullWidth>
                <InputLabel>Select or add record*</InputLabel>
                <Controller
                  control={control}
                  {...register("customer_id")}
                  render={({ field }) => (<Select
                    label="Select or add record*"
                    {...field}
                    onChange={(e) => {
                      field.onChange(e);
                      setDefaultCustomer(e.target.value);
                    }}
                  >
                    {userAddressList?.map((val) => {
                      return (<MenuItem key={val?.value} value={val?.value}>{val?.name}, {val?.address}</MenuItem>);
                    })}
                  </Select>)}
                />
              </FormControl>
            </div>

            <div className={`FormFullGroup`} style={{ marginBottom: '20px' }}>
              <Controller
                control={control}
                {...register("name", { required: "This field is Required" })}
                render={({ field }) => (<TextField {...field} label="Name*" variant="outlined" />)}
              />
              {errors.name && (<span className={`ErrorM`}>{errors?.name?.message}</span>)}
            </div>

            <div className={`FormFullGroup`} style={{ marginBottom: '20px' }}>
              <Controller
                control={control}
                {...register("email", {
                  required: "This field is Required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address"
                  }
                })}
                disabled
                render={({ field }) => (<TextField {...field} label="Email*" id="asdas" variant="outlined" />)}
              />
              {errors.email && (<span className={`ErrorM`}>{errors?.email?.message}</span>)}
            </div>

            <div className={`FormFullGroup`} style={{ marginBottom: '20px' }}>
              <Controller
                control={control}
                {...register("phone", { required: "This field is Required" })}
                render={({ field }) => (<TextField {...field} label="Phone*" variant="outlined" />)}
              />
              {errors.phone && (<span className={`ErrorM`}>{errors.phone.message}</span>)}
            </div>

            {fields.map((item, index) => {
              return (<div className={`FormFullGroup`} style={{ marginBottom: '20px' }} key={item.id}>
                <div className={`${styles.AltConSec}`}>
                  <Controller
                    control={control}
                    {...register(`alt_phones[${index}].value`, { required: "This field is Required" })}
                    render={({ field }) => (<TextField {...field} label="Alt Phone*" variant="outlined" />)}
                  />
                  <button type='button' onClick={(e) => remove(index)} className={`${styles.ConNoBU}`}><Trash2 /></button>
                </div>
                {(errors?.alt_phones?.length > 0 && errors?.alt_phones[index]?.value) && <p className={`${styles.ErrorM}`}>{errors?.alt_phones[index]?.value?.message}</p>}
              </div>)
            })}
            <button type='button' onClick={() => { append({ value: '' }); }} className={`${styles.AddAltConNO}`}><Plus /> Alt phone</button>
          </div>

          <div className={`${styles.StepOneFormSmall2}`}>
            <div className={`FormFullGroup`} style={{ marginBottom: '20px', marginLeft: 0 }}>
              <Controller
                control={control}
                {...register("address", { required: "This field is Required" })}
                render={({ field }) => (<TextField {...field} label="Address*" variant="outlined" inputRef={placeRef1} placeholder="" />)}
              />
              {errors?.address && (<p className={`${styles.ErrorM}`}>{errors?.address?.message}</p>)}
            </div>

            <div className={`FormFullGroup`} style={{ marginBottom: '20px', marginLeft: 0 }}>
              <Controller
                control={control}
                {...register("post_code", { required: "This field is Required" })}
                render={({ field }) => (<TextField {...field} label="Post Code*" variant="outlined" />)}
              />
              {errors.post_code && (<span className={`ErrorM`}>{errors?.post_code?.message}</span>)}
            </div>

            <div>
              <MapComponent center={mapCenter} zoom={zoom} isMarker={isMarker} />
            </div>
          </div>

          <div className={`${styles.StepBUSec}`}>
            <button type="button" onClick={backToTab} className={`${styles.Previous}`}>Back</button>
            <button type="submit" className={`${styles.Next}`}>Next</button>
          </div>
        </div>
      </form>
    </div>
  </>);
}

export default Step2;